import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { DateObject } from '@uplift/services';
import { useCallback } from 'react';
import { Button } from '@uplift/ui-v2';
import { MatchingProfileData } from '@uplift/api';
import { makeStyles } from 'tss-react/mui';
import { getSessionDuration } from '../helpers';

export type ConfirmDialogProps = {
  appointmentTime: DateObject;
  provider: MatchingProfileData;
  isLoading: boolean;
  onClose: (confirm?: boolean) => void;
};

export const ConfirmModal: React.VFC<ConfirmDialogProps> = ({ appointmentTime, provider, isLoading, onClose }) => {
  const { classes } = useStyles();
  const l10n = useL10n();
  const displayName = provider?.nameDisplay?.defaultDisplay || '';

  const handleClose = useCallback((confirm?: boolean) => {
    onClose(confirm);
  }, [ onClose ]);

  return (
    <Dialog open onClose={() => handleClose(false)} maxWidth="xs" fullWidth classes={{ paperWidthXs: classes.paperWidthXs }}>
      <DialogTitle>Schedule Session</DialogTitle>
      <DialogContent className={classes.content}>
        <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" gap=".5rem" pb={3}>
          <Box
            component="img"
            src={provider?.avatarAsset.url}
            alt={provider?.nameDisplay.defaultDisplay}
            width={128}
            height={128}
            display="flex"
            borderRadius="4px"
            overflow="hidden"
          />
          <Typography color="darkSlate">
            {displayName}
          </Typography>
          <Typography color="secondary" fontWeight={500}>
            {appointmentTime.format('dddd')} at {appointmentTime.format('h:mm a')}
          </Typography>
          <Typography color="darkSlate">
            {getSessionDuration(provider?.user?.medicalRole)} minute session
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap=".5rem" pt={2}>
          <Button variant="contained" color="secondary" fullWidth onClick={() => handleClose(true)} loading={isLoading}>
            {l10n.findPsychiatrist.confirm}
          </Button>
          <Button fullWidth onClick={() => handleClose(false)}>
            {l10n.findPsychiatrist.cancel}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paperWidthXs: {
    maxWidth: '346px'
  },
  content: {
    padding: theme.spacing(0, 2, 2, 2),
    paddingTop: '0 !important'
  }
}));
